import React, { createContext, useCallback, useState, useContext } from 'react';
import { IUser } from '../interfaces/IUser';
import api from '../services/api';

interface AuthState {
  token: string;
  user: IUser;
}

interface SignInCredentials {
  email: string;
  password: string;
}
interface AuthContextInterface {
  user: IUser;
  signIn(credentials: SignInCredentials): Promise<void>;
  signOut(): void;
}

export const AuthContext = createContext<AuthContextInterface>(
  {} as AuthContextInterface,
);

export const AuthProvider: React.FC = ({ children }) => {
  const [data, setData] = useState<AuthState>(() => {
    const token = localStorage.getItem('@wakeUp:token');
    const user = localStorage.getItem('@wakeUp:user');

    if (token && user) {
      api.defaults.headers.Authorization = `Bearer ${token}`;

      return { token, user: JSON.parse(user) };
    }
    delete api.defaults.headers.common.Authorization;

    return {} as AuthState;
  });
  const signIn = useCallback(async ({ email, password }) => {
    const res = await api.post('/auth/login', {
      email,
      password,
    });
    const { acessToken, user } = res.data;
    localStorage.setItem('@wakeUp:token', acessToken);
    localStorage.setItem('@wakeUp:user', JSON.stringify({ ...user }));
    api.defaults.headers.Authorization = `Bearer ${acessToken}`;

    setData({ token: acessToken, user });
  }, []);

  const signOut = useCallback(() => {
    localStorage.removeItem('@wakeUp:token');
    localStorage.removeItem('@wakeUp:user');
    delete api.defaults.headers.Authorization;

    setData({} as AuthState);
  }, []);

  return (
    <AuthContext.Provider value={{ user: data.user, signIn, signOut }}>
      {children}
    </AuthContext.Provider>
  );
};

export function useAuth(): AuthContextInterface {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuth must be used withn an AuthProvider');
  }

  return context;
}
